<template>
  <div>
    <PortalTarget name="agreement-popup" />
    <div v-if="!isLoading" class="wrap">
      <div v-if="device === 'mobile'" class="sticky-area">
        <CommonHeader
          title="Wavve 상품 구매"
          :is-back-btn="false"
          :is-close-btn="true"
          :close-fn="closeVoucher"
        />
      </div>
      <div v-if="!isEmptyList" class="voucher-wrap">
        <!-- 이용권 리스트 출력 -->
        <template v-if="dataList">
          <PopupVoucherCategory
            v-for="(data, index) in dataList"
            :key="index"
            :category="data"
            :category-index="index"
            :package-detail-list="packageDetailList"
            :purchase-fn="purchase"
          />
        </template>
        <PopupVoucherGuide />
      </div>
      <div v-else class="ticket-wrap">
        <MyPooqEmptyList info-text="구매 가능한 상품이 없어요." />
        <div class="voucher-wrap">
          <PopupVoucherGuide />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PopupVoucherCategory from '@/components/voucher/PopupVoucherCategory'
  import {
    BottomTabService,
    MyPooqService,
    VoucherService,
  } from '@/common/api/api.service'
  import { get, filter } from 'lodash'
  import utils from '@/common/util/utils'
  import MyPooqEmptyList from '@/components/lnb/mypooq/MyPooqEmptyList'
  import PopupVoucherGuide from '@/components/voucher/PopupVoucherGuide'
  import VoucherBottomGuide from '@/components/lnb/voucher/VoucherBottomGuide'
  import { voucherPurchase } from '@/common/util/common'
  import CommonHeader from '@/components/header/template/commonHeader'
  import { DEVICE_TYPE_IOS } from '@/common/devicetype.const'
  import {
    PAYMENT_GATE_TYPE_GOOGLE_IN_APP_PURCHASE,
    PAYMENT_GATE_TYPE_ONE_STORE,
    PRODUCT_TYPE_PRODUCT,
    PRODUCT_TYPE_SUBSCRIPTION,
  } from '@/common/constant'
  import braze from '@/common/util/braze'
  import {
    normalizePurchaseParams,
    getPurchaseProperties,
  } from '@/common/util/braze.util'

  export default {
    name: 'VoucherPopup',
    components: {
      CommonHeader,
      PopupVoucherCategory,
      MyPooqEmptyList,
      PopupVoucherGuide,
      VoucherBottomGuide,
    },
    data() {
      return {
        dataList: [],
        type: '',
        cpid: '',
        channelid: '',
        programid: '',
        contentid: '',
        contenttype: '',
        device: utils.cookies.getDevice(),
        isplayy: 'n',
        download: 'N',
        isLoading: false,
        isEmptyList: false,
        packageDetailList: [],
      }
    },
    created() {
      this.initialize()
      this.setData()
    },
    mounted() {
      window.addEventListener('message', this.postMessage)
    },
    beforeDestroy() {
      window.removeEventListener('message', this.postMessage)
    },
    methods: {
      purchase(voucher, categoryIndex) {
        const productTypeForGoogleIAP = (isAuto) => {
          return isAuto ? PRODUCT_TYPE_SUBSCRIPTION : PRODUCT_TYPE_PRODUCT
        }
        const productType = get(
          this.dataList,
          [categoryIndex, 'passgroup_type'],
          '',
        )
        const pgName =
          productType === 'one' || productType === 'package'
            ? ''
            : utils.getPgName()
        const productId = get(voucher, 'productid', '')
        voucherPurchase({
          deviceType: this.device,
          productId,
          contentType: this.contenttype,
          contentId: this.contentid,
          pgName,
          productTypeForGoogleIAP: productTypeForGoogleIAP(
            get(voucher, 'is_auto', false),
          ),
          ...this.getCallbackInfo(voucher, productId, productType),
        })
      },
      getCallbackInfo(voucher, productId, productType) {
        if (productType === 'voucher') {
          const productDetailList = get(
            voucher,
            'purchase_amount_info_list',
            [],
          )
          const productDetail = productDetailList.find(
            (product) => product.productid === productId,
          )
          return {
            callbackAction: 'purchaseComplete',
            callbackParams: {
              next: 'closePopup',
              productType,
              ...normalizePurchaseParams({ ...voucher, ...productDetail }),
            },
            canceledCallbackAction: 'Cancel',
          }
        }

        return {
          callbackAction: 'purchaseComplete',
          callbackParams: {
            next: 'closePopup',
            productType,
          },
          canceledCallbackAction: 'Cancel',
        }
      },
      closeVoucher() {
        this.initialize()
        this.$router.back()
      },
      getVoucherType({ pgName = '', type }) {
        if (
          pgName === PAYMENT_GATE_TYPE_ONE_STORE ||
          pgName === PAYMENT_GATE_TYPE_GOOGLE_IN_APP_PURCHASE
        ) {
          return pgName
        } else {
          return type === 'movie' ? 'all' : type
        }
      },
      initialize() {
        this.dataList = []
        this.type = get(this.$route, ['query', 'type'], 'voucher')
        this.cpid = get(this.$route, ['query', 'cpid'], '')
        this.channelid = get(this.$route, ['query', 'channelid'], '')
        this.programid = get(this.$route, ['query', 'programid'], '')
        this.contentid = get(this.$route, ['query', 'contentid'], '')
        this.contenttype = get(this.$route, ['query', 'contenttype'], '')
        this.isplayy = get(this.$route, ['query', 'playy'], 'n')
        this.download = get(this.$route, ['query', 'downloadyn'], 'N')
      },
      packageDetailInfo(dataList) {
        const packageInfo = get(
          filter(dataList, (item) => item.passgroup_type === 'package'),
          '0',
          {},
        )
        const productgroups = get(packageInfo, 'productgroups', [])
        productgroups.forEach((productGroup) => {
          const productId = get(
            productGroup,
            'products.0.concurrency.0.productid',
            '',
          )
          MyPooqService.myPurchaseContentPackageDetail({
            productid: productId,
            contenttype: 'movie',
            offset: 0,
            limit: 50,
          }).then(({ data }) => {
            const list = get(data, '0.list', [])
            this.packageDetailList.push({ productId: productId, list: list })
          })
        })
      },
      setData() {
        const isIOS = this.device === DEVICE_TYPE_IOS
        if (this.isLoading) return
        this.isLoading = true
        const params = {
          cpid: this.cpid,
          channelid: this.channelid,
          programid: this.programid,
          contentid: this.contentid,
          contenttype: this.contenttype,
          vouchertype: this.getVoucherType({
            pgName: utils.getPgName(),
            type: this.type,
          }),
          isplayy: this.isplayy,
          downloadyn: this.download,
        }
        // INFO: IOS 일때 static json 호출
        const request = isIOS
          ? VoucherService.getPlayyOnlyVoucherList()
          : BottomTabService.purchaseProductsNew(params)
        request.then((response) => {
          this.dataList = get(response, 'data', {})
          this.packageDetailInfo(this.dataList)
          const emptyList = this.dataList.filter(
            (voucher) => voucher.productgroups_count === '0',
          )
          this.isEmptyList = this.dataList.length === emptyList.length
          this.isLoading = false
        })
      },
      async postMessage(e) {
        if (e.origin === location.origin) {
          const { eventMessage, params = {} } = e.data
          if (eventMessage === 'purchaseComplete' && params.result === 'y') {
            if (params.productType === 'voucher') {
              braze.purchase(getPurchaseProperties(params))
            }
            const credential = utils.cookies.getCredential()
            const isMultiLine =
              Number(utils.cookies.userInfo('profilecount')) !== 1
            await utils.login.credentialAutoLogin(
              credential,
              isMultiLine,
              false,
            )
            switch (params.next) {
              case 'reload':
                window.location.reload(true)
                break
              case 'setData':
                this.setData()
                break
              case 'closePopup':
                this.closeVoucher()
                break
              default:
                break
            }
          }
        }
      },
    },
  }
</script>
<style lang="css" src="@/assets/new-css/voucher.css"></style>
<style scoped>
  .guide-wrapper {
    margin-bottom: 0;
  }
</style>
